import { render, staticRenderFns } from "./integrationList.vue?vue&type=template&id=04425d80&"
import script from "./integrationList.vue?vue&type=script&lang=js&"
export * from "./integrationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports